import { Box, Typography } from "@mui/material";
import { useRTL } from "hooks/isRTL";
import { useNavigate } from "react-router-dom";

/**
 * Displays the header section of a flashing card, including the order number and status.
 * The order number is clickable and navigates to the relevant page based on the status.
 *
 * @component
 * @param {Object} props  The component props.
 * @param {string} props.orderNumber  The order number to display.
 * @param {string} props.status  The status of the order (e.g., "Pending", "Resolved").
 * @param {string} props.orderId  The ID of the order (used for navigation if status is not "driverChangeRequest").
 * @param {string} props.rowId  The ID of the row (used for navigation if status is "driverChangeRequest").
 *
 * @returns {JSX.Element} The rendered component.
 */
function FlashingCardHeader({
  orderNumber,
  status, //type
  statusColor,
  convertToArabicNumbers,
  orderId, // the order id if the status not requestDriverChange nor 17
  rowId, // the row id (for the change request )
}) {
  const { t, isRTL } = useRTL();
  const navigate = useNavigate();
  const handleNavigation = () => {
    if (status === t("driverChangeRequest")) {
      navigate(`/drivers-requests/${rowId}`);
    } else {
      navigate(`/orders/${orderId}`);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 500,
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={handleNavigation}
      >
        {`${t("orderNumber")} ${
          isRTL ? convertToArabicNumbers(orderNumber) : orderNumber
        }`}
      </Typography>
      <Typography
        sx={{
          padding: "0.3rem 0.7rem",
          borderRadius: "99px",
          color: statusColor || "#000",
          backgroundColor: `${statusColor}1A`,
          border: `1px solid ${statusColor || "#000"}`,
        }}
      >
        {t(status)}
      </Typography>
    </Box>
  );
}

export default FlashingCardHeader;
